/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { Box, Button, Stack, useTheme } from "@mui/material";
import { activateRoomtype, enhanceRoomtype, listAllFacilities, listAllHighlights, listAllRoomTypes, listRoomTypeDetails, resetAllRoomTypesList, resetRoomTypeDetails } from "../../store/actions";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector, useDispatch } from "react-redux";
import { Add, ArrowForward } from "@mui/icons-material";
import StarIcon from '@mui/icons-material/Star';
import { useNavigate } from "react-router-dom";
import { PaginationFooter, tableStyle } from "../../components";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import AvailabilityUpdation from "../../components/AvailabilityUpdation";
import ConfirmModal from "../../components/ConfirmModal";
import { toast } from "react-toastify";

const RoomTypes = () => {
  const [openModal, setOpenModal] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const flexible_occupancy = useSelector(
  ({ registration: { hotelProfile } }) => hotelProfile.flexible_occupancy
);
  const headerTitle = flexible_occupancy ? (
  <span>
    ROOM TYPES <StarIcon style={{ fontSize: 18, color: 'gold' }} />
  </span>
) : (
  "ROOM TYPES"
);

  const { roomTypesList, pageNumber, pageSize, count } = useSelector(
    ({
      admin: {
        roomTypes: { list, pageNumber, pageSize, count },
      },
    }) => ({
      roomTypesList: list,
      pageNumber,
      pageSize,
      count,
    })
  );
  useEffect(() => {
    document.title = 'Room Types';
    dispatch(resetAllRoomTypesList());
    dispatch(listAllRoomTypes());
    dispatch(listAllHighlights());
    dispatch(listAllFacilities());
  }, []);

  const fetchMoreData = (page) => {
    dispatch(listAllRoomTypes(page));
  }

  const CustomFooter = () => {
    return (
      <PaginationFooter 
        count={count}
        pageSize={pageSize}
        pageNumber={pageNumber}
        fetchMoreData={(page) => fetchMoreData(page)}
      />
    );
  }

  const columns = [
    { field: "name", headerName: "Name", cellClassName: "name-column--cell", width: 200 },
    { field: "description", headerName: "Description", width: 250 },
    // { field: "no_of_beds", headerName: "Number of beds", width: 120 },
    { field: "min_no_of_people", headerName: "Min. number of people", width: 170 },
    { field: "max_no_of_people", headerName: "Max. number of people", width: 170 },
    // {
    //   field: "is_active",
    //   headerName: "Availability",
    //   width: 100,
    //   renderCell: ({ row: { is_active } }) => {
    //     return (
    //       <Chip
    //         size="small"
    //         variant="outlined"
    //         label={is_active ? "active" : "inactive"}
    //         color={is_active ? "primary" : "warning"}
    //       />
    //     );
    //   },
    // },
    {
      field: "is_active",
      headerName: "Availability",
      width: 100,
      renderCell: ({ row: { is_active, _id, name } }) => {
        return (
          <AvailabilityUpdation
            name={name}
            isActive={is_active}
            action={() => dispatch(activateRoomtype({ id: _id }))}
          />
        );
      },
    },
    {
      field: "_id",
      headerName: "View details",
      width: 150,
      renderCell: ({ row: { _id } }) => {
        return (
          <Button
            size="small"
            variant="contained"
            onClick={async () => {
              await dispatch(resetRoomTypeDetails());
              await dispatch(listRoomTypeDetails({ id: _id }));
              navigate(`/roomtype-details/${_id}`);
            }}
            endIcon={<ArrowForward fontSize="small" />}
            sx={{ fontWeight: 600 }}
          >
            View
          </Button>
        )
      },
    },
  ];

  const handleConfirmAction =async () => {
    // Your action code here (e.g., navigating, making API calls)
     let res = await dispatch(enhanceRoomtype({flexible_occupancy: true}));
      if (res) toast.success("Data updated successfully");
    // Add your navigate logic here if needed, e.g., navigate("/roomtype-creation")
  };
const buttonStyle = {
  backgroundColor: colors.blueAccent[700],
  color: colors.grey[100],
  fontSize: "14px",
  fontWeight: "bold",
  padding: "10px 20px",
  display: "flex",
  alignItems: "center",
  marginRight: "10px", // Adds space between the buttons
};
  return (
    <Box m="20px" mb={15}>
      <Stack
        direction={{ sm: "row", xs: "column" }}
        justifyContent={{ sm: "space-between", xs: "start" }}
        alignItems={{ sm: "center", xs: "start" }}
        m="20px 0"
      >
        <Header title={headerTitle} subtitle="welcome to Room Types" />
<Box display="flex" flexDirection="row">
  {!flexible_occupancy && (
    <Button sx={buttonStyle} 
    onClick={() => setOpenModal(true)}>
      Enhance room types
    </Button>
  )}
  <Button sx={buttonStyle} onClick={() => navigate("/roomtype-creation")}>
    <Add sx={{ mr: "10px" }} />
    Create room types
  </Button>
</Box>
      </Stack>
      <Box
        m="8px 0 0 0"
        height="80vh"
        sx={tableStyle(colors)}
      >
        <DataGrid
          rows={roomTypesList}
          columns={columns}
          components={{ Footer: CustomFooter }}
          getRowId={(row) => row?._id}
        />
      </Box>
       <ConfirmModal
        open={openModal} // Modal visibility state
        setModal={setOpenModal} // Function to close the modal
        text={modalText}
        action={handleConfirmAction} // The action to execute if the user confirms
      />
    </Box>
  );
};

export default RoomTypes;

const modalText = "Enhancing room types will allow you to have more than 3 people in the room. This needs to be done manually in all room types to enable this feature, and it cannot be undone. Are you sure you want to proceed?";
